import { Directive, effect, input, signal } from '@angular/core'

import { fonts, theme } from '@flowx/core-sdk'
import { ErrorOverrides, applyErrorCustomStyles } from '@flowx/core-theme'

@Directive({
  selector: 'flx-error',
  host: {
    '[class]': 'styleClassName()',
  },
  standalone: true,
})
export class FlxErrorStyleDirective {
  componentStyle = input<{
    style: ErrorOverrides
  }>()

  styleClassName = signal<string>('')

  constructor() {
    effect(async () => {
      const style = this.componentStyle()?.style
      if (!style) {
        return
      }
      const className = await applyErrorCustomStyles(style, theme(), fonts())
      this.styleClassName.set(className)
    })
  }
}
